import React, { useState, useRef } from 'react';
import GlobalFilter from '../../../../../Components/Table/GlobalTableFilter';
import ImageViewer from '../../../../../Components/ImageViewer';

function AssignmentSolutionTable({ 
  data, 
  modeFilter,
  onFilterChange =  () => {},
  onRowClick = () => {}
}) {
  const [globalFilter, setGlobalFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');

  const componentRef = useRef();

  const tableData = data.length > 0 ? data: [];

  // Filter data based on search and status
  const filteredData = tableData.filter(item => {
    const matchesSearch = !globalFilter || item.title.toLowerCase().includes(globalFilter?.toLowerCase());
    
    const matchesStatus = statusFilter === 'all' || item.status === statusFilter;
    
    return matchesSearch && matchesStatus;
  });


  return (
    <>
      <div className="d-flex w-100 justify-content-between p-3">
        <GlobalFilter
            globalFilter={globalFilter}
            setGlobalFilter={setGlobalFilter}
        />

        <div className="d-flex gap-4 px-4">
            <div className="filter-container">
                <select
                    className="filter-dropdown"
                    value={modeFilter}
                    onChange={(e) => {    
                        onFilterChange(e.target.value)               
                    }}
                >
                    {/* <option value="all">All </option> */}
                    <option value="assignment">Assignments</option>
                    <option value="solution">Solutions</option>
                </select>
                </div>

                <div className="filter-container">
                <select
                    className="filter-dropdown"
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                >
                    <option value="all">All Status</option>
                    <option value="pending">Pending</option>
                    <option value="submitted">Submitted</option>
                </select>
            </div>
        </div>
        
      </div>

      <div className="table-container" style={{ overflowX: "auto" }}>
        <table
          style={{
            font: "poppins",
            fontWeight: "400",
            fontSize: "14px",
            minWidth: "100%",
            width: "max-content",
          }}
        >
          <table className="w-100" ref={componentRef}>
            <thead>
              <tr>
                <th style={{ fontWeight: "600" }}>Title</th>
                <th style={{ fontWeight: "600" }}>Date</th>
                <th style={{ fontWeight: "600" }}>Type</th>
                <th style={{ fontWeight: "600" }}>Status</th>
                <th style={{ fontWeight: "600" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((item) => (
                  <tr 
                    key={item.id}
                    className="border-top border-bottom table-row"
                    onClick={() => onRowClick(item)}
                  >
                    <td style={{ textTransform: "capitalize" }}>{item.title}</td>
                    
                    <td style={{ textTransform: "capitalize" }}>
                      {new Date(item.created_at).toLocaleDateString()}
                    </td>
                    <td style={{ textTransform: "capitalize" }}>
                      <span className={`type-badge ${item.entity_type}-badge`}>
                        {item.entity_type}
                      </span>
                    </td>
                    <td style={{ textTransform: "capitalize" }}>
                      <span className={`status-badge status-${item.status}`}>
                        {item.status}
                      </span>
                    </td>
                    <td>
                      <ImageViewer
                        images={
                        item.entity_type === "assignment" ? item.assignment_files : item.submission_files
                        }
                        date={item.created_at }
                        text={"View Attachments"}
                        fileType={item.extension === "pdf" ? "pdf" : "image"}
                    />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center", padding: "20px", color: "#8E8E8E" }}>
                    No assignments or solutions found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </table>
      </div>

      <style jsx="true">{`
        th {
          padding: 12px;
          background-color: #fcfcfd;
        }
        td {
          padding: 12px;
        }
        .table-row:hover {
          box-shadow: inset 1px 0 0 #dadce0, inset -1px 0 0 #dadce0,
            0 1px 2px 0 rgb(60 64 67 / 30%), 0 1px 3px 1px rgb(60 64 67 / 15%);
          cursor: pointer;
        }
        .search-input {
          padding: 10px 15px;
          border: 1px solid #dadce0;
          border-radius: 4px;
          outline: none;
          width: 300px;
          font-size: 14px;
          color: #333;
        }
        .search-input:focus {
          border-color: #009B94;
          box-shadow: 0 0 0 2px rgba(0, 155, 148, 0.2);
        }
        .filter-dropdown {
          padding: 10px 15px;
          border: 1px solid #dadce0;
          border-radius: 4px;
          outline: none;
          background: white;
          font-size: 14px;
          color: #333;
          cursor: pointer;
        }
        .filter-dropdown:focus {
          border-color: #009B94;
          box-shadow: 0 0 0 2px rgba(0, 155, 148, 0.2);
        }
        .type-badge, .status-badge, .grade-badge {
          padding: 4px 8px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 500;
          text-transform: uppercase;
        }
        .assignment-badge {
          background-color: #e3f2fd;
          color: #1976d2;
        }
        .solution-badge {
          background-color: #f3e5f5;
          color: #7b1fa2;
        }
        .status-pending {
          background-color: #fff3cd;
          color: #856404;
        }
        .status-submitted {
          background-color: #d4edda;
          color: #155724;
        }
        @media print {
          .search-input, .filter-dropdown, .btn {
            display: none;
          }
        }

      `}</style>
    </>
  );
}

export default AssignmentSolutionTable;